import { Outlet } from "react-router-dom";
import GoogleMap from "google-map-react";
import ContactForm from "../../components/contact-form/contact-from.component";
import { SiteContext } from "../../contexts/site-context";
import { useContext } from "react";
const Contact = () => {
  const { siteSettings } = useContext(SiteContext);
  const externalUrl = (url) => {
    if (!url.match(/^[a-zA-Z]+:\/\//)) {
      return (url = "https://" + url);
    }
  };
  const defaultProps = {
    center: {
      lat: 23.033863,
      lng: 72.585022,
    },
    zoom: 12,
  };

  return (
    <div>
      <section className="inner_page_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="breadcrumb_content">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Contact
                  </li>
                </ol>
                <h4 className="breadcrumb_title">Contact Us</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our-contact pb0 bgc-f7">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-xl-8">
              <div className="form_grid">
                <h4 className="mb5">Send Us An Email</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                  gravida quis libero eleifend ornare. Maecenas mattis enim at
                  arcu feugiat, sit amet blandit nisl iaculis. Donec lacus odio,
                  malesuada eu libero sit amet, congue aliquam leo. In hac
                  habitasse platea dictumst.
                </p>
                <ContactForm />
              </div>
            </div>
            <div className="col-lg-5 col-xl-4">
              <div className="contact_localtion">
                <h4>Contact Us</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                  gravida quis libero eleifend ornare. habitasse platea
                  dictumst.
                </p>
                <div className="content_list">
                  <h5>Address</h5>
                  <p>
                    {siteSettings ? siteSettings.general_info.address : null}
                  </p>
                </div>
                <div className="content_list">
                  <h5>Phone</h5>
                  <p>{siteSettings ? siteSettings.general_info.phone : null}</p>
                </div>
                <div className="content_list">
                  <h5>Mail</h5>
                  <p>{siteSettings ? siteSettings.general_info.email : null}</p>
                </div>
                <div className="content_list">
                  <h5>Skype</h5>
                  <p>centraltx.com</p>
                </div>
                <h5>Follow Us</h5>
                <ul className="contact_form_social_area">
                  <li className="list-inline-item">
                    <a
                      href={
                        siteSettings
                          ? externalUrl(siteSettings.social_media.facebook)
                          : null
                      }
                      target="_blank"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href={
                        siteSettings
                          ? externalUrl(siteSettings.social_media.twitter)
                          : null
                      }
                      target="_blank"
                    >
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href={
                        siteSettings
                          ? externalUrl(siteSettings.social_media.instagram)
                          : null
                      }
                      target="_blank"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href={
                        siteSettings
                          ? externalUrl(siteSettings.social_media.linkedin)
                          : null
                      }
                      target="_blank"
                    >
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href={
                        siteSettings
                          ? externalUrl(siteSettings.social_media.skype)
                          : null
                      }
                      target="_blank"
                    >
                      <i className="fa fa-skype"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid p0 mt50">
          <div className="row">
            <div className="col-lg-12">
              <div className="h600" id="map-canvas">
                <GoogleMap
                  defaultCenter={defaultProps.center}
                  defaultZoom={defaultProps.zoom}
                ></GoogleMap>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Outlet />
    </div>
  );
};

export default Contact;
